/**
 * BOM管理 - 枚举定义
 * 
 * 【文件职责】
 * 定义BOM管理模块的所有枚举类型，包括生命周期状态、BOM状态、BOM明细状态等。
 * 
 * 【对应后端】
 * - backend/app/Modules/Bom/Models/Bom.php (常量定义)
 * - backend/app/Modules/Bom/Models/BomItem.php (常量定义)
 * 
 * 【注意事项】
 * 1. 枚举值必须与后端完全一致（包括大小写）
 * 2. 每个枚举值都需要添加中文注释
 * 3. 枚举类型使用 PascalCase 命名
 * 4. 枚举值使用 UPPER_SNAKE_CASE 命名
 * 
 * 【更新时机】
 * - 后端新增枚举类型时
 * - 后端枚举值发生变化时
 * - 需要添加新的业务状态时
 * 
 * 【验证方式】
 * 对照 Bom.php 和 BomItem.php 中的常量定义，确保：
 * - 枚举值完全一致
 * - 中文描述准确
 * - 无遗漏、无多余
 * 
 * @last-updated 2025-10-18
 */

/**
 * BOM 生命周期状态
 * 
 * 对应后端：Bom::LIFECYCLE_*
 */
export enum BomLifecycleStatus {
  /** 设计中 - 初始状态，可以编辑和删除 */
  DESIGN = 'DESIGN',
  
  /** 待审核 - 提交审核后的状态，可以编辑 */
  PENDING = 'PENDING',
  
  /** 已发布 - 审核通过后的状态，不可编辑，可用于生产 */
  RELEASED = 'RELEASED',
  
  /** 冻结 - 暂时不使用，保留历史版本 */
  FROZEN = 'FROZEN',
  
  /** 淘汰 - 已废弃，不再使用 */
  OBSOLETE = 'OBSOLETE',
}

/**
 * BOM 状态
 * 
 * 对应后端：Bom::STATUS_*
 */
export enum BomStatus {
  /** 启用 */
  ACTIVE = 1,
  
  /** 停用 */
  INACTIVE = 0,
}

/**
 * BOM 明细状态
 * 
 * 对应后端：BomItem::STATUS_*
 */
export enum BomItemStatus {
  /** 启用 */
  ACTIVE = 1,
  
  /** 停用 */
  INACTIVE = 0,
}

